import React, { forwardRef } from "react";
import classNames from "classnames";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

import { nutritionDetailsFields } from "../../util/helpers.js";
import ReactMarkdown from "react-markdown";

const NutritionDetails = forwardRef(
  (
    {
      product_details,
      detailType,
      label,
      id,
      openedId,
      handleDestCollapsible,
      position = "catalog",
      showNutritionDetailsField = false,
      separator = false,
      content,
    },
    ref,
  ) => {
    // If there's no product_details object at all, do nothing
    if (!product_details) return null;

    let detailId;
    let detailContent = "";

    if (showNutritionDetailsField) {
      // Nutritional Values
      detailId = "nutritional_values" + id;
    } else {
      // Normal detail
      detailId = detailType + id;
      detailContent = content ?? product_details[detailType];
      if (!detailContent) return null;
    }

    // TODO: Rename and unify CSS classes.
    // - 'nutritional_value' refers to the list of nutrition details fields.
    // - 'description' is used for rendering a specific detail.
    const kind = showNutritionDetailsField
      ? "nutritional_value"
      : "description";

    return (
      <>
        <div
          className={`${position}-item__edit-inner-${kind}`}
          onClick={(e) => {
            e.stopPropagation();
            handleDestCollapsible(detailType);
          }}
        >
          <div className={`${position}-item__edit-inner-${kind}-text`}>
            <p>{label}</p>
          </div>
          <div className="icon">
            {detailId === openedId ? (
              <RiArrowUpSLine size={22} color={"gray"} />
            ) : (
              <RiArrowDownSLine size={22} color={"gray"} />
            )}
          </div>
        </div>
        <div
          className={classNames(`${position}-item__hide-${kind}`, {
            [`${position}-item__show-${kind}`]: detailId === openedId,
          })}
        >
          {showNutritionDetailsField &&
            Object.entries(nutritionDetailsFields).map(([key, value]) => {
              return (
                <div
                  className={`${position}-item__edit-${kind}-detail`}
                  key={key + value}
                >
                  <span>{value}</span>
                  <span>{product_details[key] || 0} g</span>
                </div>
              );
            })}
          {!showNutritionDetailsField && (
            <div className={`${position}-item__show-${kind}-p`}>
              <div className="md-content">
                <ReactMarkdown>{detailContent}</ReactMarkdown>
              </div>
            </div>
          )}
        </div>
        {separator && <div className={"thin-top-border"}></div>}
      </>
    );
  },
);

export default NutritionDetails;
